export default {
  name: 'user-sessions',
  translationKey: 'user-sessions-module',
  routePrefix: 'user-sessions',
  routeNamePrefix: 'user-sessions',
  directRoutesAvailable: true,
}
